import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Simple scroll restoration:
// - Save scroll position before navigation
// - On PUSH: scroll to top
// - On POP (back/forward): restore saved position
const positions = new Map<string, number>();

export default function ScrollRestoration() {
  const { key, pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const saveScroll = () => {
      positions.set(key, window.scrollY);
    };
    window.addEventListener("scroll", saveScroll, { passive: true });
    return () => {
      positions.set(key, window.scrollY);
      window.removeEventListener("scroll", saveScroll);
    };
  }, [key]);

  useEffect(() => {
    if (navType === "POP") {
      const y = positions.get(key) ?? 0;
      window.scrollTo({ top: y, left: 0, behavior: "auto" });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, key]);

  return null;
}